module.exports = __webpack_public_path__ + "img/SomethingRotten6.7abe731d.png";